// extracted by mini-css-extract-plugin
export default {"container":"AX-z","title":"BX-z","link":"CX-z"};